import { formatMessageIntlUtil } from '@gymaholic/packages'
import ContentBox from 'components/ContentBox'
import Page from 'components/Page'
import TextBody from 'components/TextBody'
import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import Link from 'components/Link'
import PageSubTitle from '../Page/Page.SubTitle.js'
import PageTitle from '../Page/Page.Title.js'

const messages = defineMessages({
  title: {
    id: 'NotFound.title',
    defaultMessage: 'Page Not Found'
  },
  description: {
    id: 'NotFound.description',
    defaultMessage: 'Sorry, but this page does not exist.'
  },
  redirect: {
    id: 'NotFound.redirect',
    defaultMessage: 'Find something {link}'
  },
  link: {
    id: 'NotFound.link',
    defaultMessage: 'interesting to read here.'
  }
})

export default function NotFound () {
  const intl = useIntl()
  return (
    <Page>
      <ContentBox>
        <PageTitle>{formatMessageIntlUtil(intl, messages.title)}</PageTitle>
        <PageSubTitle>{formatMessageIntlUtil(intl, messages.description)}</PageSubTitle>
        <p>
          {
            formatMessageIntlUtil(intl, messages.redirect, {
              link: <TextBody style={{ color: STYLES_COLOR.BLUE }}><Link to='/'>{formatMessageIntlUtil(intl, messages.link)}</Link></TextBody>
            })
          }
        </p>
      </ContentBox>
    </Page>
  )
}
